import './index.scss'
import projects from '../../../data/projects'

const BugReportDetail = () => {
  const project = projects.find((p) => p.slug === 'bug-report-classifier') || {}

  return (
    <main className="project-detail">
      <div className="site-container">
      <section className="project-detail__hero">
        <h1>{project.title}</h1>
        <h3>{project.role} @ {project.organisation} ({project.timeline})</h3>
        {project.skills && (
          <ul className="project-detail__skills">
            {project.skills.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        )}
      </section>

      <section className="project-detail__content">
        <p>{project.description}</p>

        <div className="project-detail__image_box">
          {project.evidence_image && <img src={project.evidence_image} alt="Evidence" className="project-detail__evidence_image" />}
        </div>

        <h3>Problem Overview</h3>
        <p>{project.problem_overview}</p>

        <h3>Implementation Details</h3>
        <ul className="project-detail__implementation">
          {project.implementation_bullets.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>
        
        <h3>Technical Highlights</h3>
        <table className="project-detail__tech-table">
          <tr>
            <th>Area</th>
            <th>Approach</th>
          </tr>
          {project.technical_details_table.map(([title, text], index) => (
            <tr key={index}>
              <td>{title}</td>
              <td>{text}</td>
            </tr>
          ))}
        </table>

        <p><b>{project.technical_details_paragraph}</b></p>

        <h3>Results</h3>
        <p>{project.results_summary}</p>
        <table className="project-detail__results-table">
          <tr>
            <th>Dataset</th>
            <th>Naive Bayes</th>
            <th>Logistic Regression</th>
          </tr>
          {project.results_table_data.map(([dataset, nb, lr], index) => (
            <tr key={index}>
              <td><b>{dataset}</b></td>
              <td>{nb}</td>
              <td>{lr}</td>
            </tr>
          ))}
        </table>
        <p>{project.results_description}</p>

        <h3>Key Takeaways</h3>
        <ul className="project-detail__key-takeaways">
          {project.key_takeaways.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>
        <p><b>Key Results: </b> {project.key_results_text}</p>

        <h3>My Contribution</h3>
        <p>{project.contribution_summary}</p>
        <p><b>Technologies used:</b> {project.tech_bullets && project.tech_bullets.join(', ')}</p>

        <p><b>Report Unavaliable</b></p>
      </section>
      </div>
    </main>
  )
}

export default BugReportDetail
